const DEFAULT_PHYSICIAN_INFO: any = {
  firstName: '',
  lastName: '',
  title: undefined,
  country: undefined,
  address: undefined,
  city: undefined,
  state: undefined,
  zip: undefined,
  phone1: undefined,
  nightPhone: undefined,
  email: undefined,
  fax: undefined,
};

const idArr = [
  'firstName',
  'lastName',
  'title',
  'npi',
  'country',
  'address',
  'city',
  'state',
  'zip',
  'phone1',
  'nightPhone',
  'email',
  'fax',
];

export { DEFAULT_PHYSICIAN_INFO, idArr };
